module.exports = __webpack_public_path__ + "img/LH-zapier-graphic-hero-right.28d658d4.svg";